module.exports = __webpack_public_path__ + "static/img/boothStep5.1306b5e5.jpg";